import { ReactNode } from 'react'

interface SettingsTitleProps {
  icon: ReactNode
  title: string
  description: string
}

export const SettingsTitle = ({ title, description, icon }: SettingsTitleProps) => {
  return (
    <section className="flex flex-col gap-2 rounded-xl border border-border-secondary bg-fg-secondary p-6 text-center md:px-20 lg:px-40">
      <div className="flex w-full justify-center p-3">
        <div
          className="rounded-xl bg-fg-brand-primary p-2 text-white"
          style={{
            background: 'linear-gradient(#0EA5E9 0, #38BDF8 100%)',
          }}
        >
          {icon}
        </div>
      </div>
      <p className="text-[24px] font-medium">{title}</p>
      <p className="text-text-tertiary">{description}</p>
    </section>
  )
}
